import {
  Button,
  Modal,
  TextField,
  Box,
  Stack,
  Slider,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useState } from "react";
import ProBox from "../Signups/ProBox";
import moment from "moment";
import GameDivisionRequest from "../Signups/GameDivisionRequest";
import PoloRating from "./PoloRating";

function RegistrationModal({
  managerMode,
  devPort,
  editMode,
  clubId,
  gameId,
  playerId,
  playerModal,
  setPlayerModal,
  baseEdit,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  rating,
  setRating,
  playerClubRating,
  setPlayerClubRating,
  playerUSPARating,
  setPlayerUSPARating,
  playerHasSignedWaiver,
  setPlayerHasSignedWaiver,
  chukkerNumber,
  setChukkerNumber,
  refresh,
  proRequest,
  isPro,
  setIsPro,
  divisionChukkers,
  setDivisionChukkers,
  gameDivisions = [],
  totalDivisionChukkers = 0,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  console.log("PRO TEST");
  console.log(isPro);
  console.log(divisionChukkers);
  const [idPro, setIdPro] = useState("-1");
  
  const [updateWaiverSignedDate, setUpdateWaiverSignedDate] = useState(false);
  
  const numberChukkers = [];
  for (var i = 1; i <= 20; i++) {
    numberChukkers.push({ label: i, value: i });
  }
  function updateFirstName(event) {
    console.log(event.target.value);
    setFirstName(event.target.value);
  }
  function updateLastName(event) {
    console.log(event.target.value);
    setLastName(event.target.value);
  }

  function updateChukkerNumber(event) {
    console.log(event.target.value);
    setChukkerNumber(event.target.value);
  }
  function resetModal() {
    setFirstName("");
    setLastName("");
    setChukkerNumber(2);
    setRating(-2);
  }
  function ChukkerDisplay() {
    if (!baseEdit) {
      return (
        <div>
          <div>Number of Chukkers</div>
          <Box sx={{ width: 350 }}>
            <Slider
              aria-label="Number of Chukkers"
              min={1}
              max={20}
              value={chukkerNumber}
              step={1}
              onChange={updateChukkerNumber}
              valueLabelDisplay="auto"
              marks={numberChukkers}
            />
          </Box>
        </div>
      );
    }
    return;
  }
  function registerPlayer() {
    if (!firstName) {
      window.alert("Enter First Name");
    } else {
      if (!lastName) {
        window.alert("Enter Last name");
      } else {
        const fetch_add_player = devPort + "add_club_player";
        const player_details = {
          club_id: clubId,
          player_id: playerId,
          first_name: firstName,
          last_name: lastName,
          uspa_rating: playerUSPARating,
          club_rating: playerClubRating,
          is_club_pro: isPro,
          has_signed_waiver: playerHasSignedWaiver,
        };
        console.log(fetch_add_player);
        fetch(fetch_add_player, {
          credentials: "include",
          mode: "cors",
          method: "POST",
          body: JSON.stringify(player_details),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log("AAAAAAA")
            console.log(data)
            if (data) {
              console.log("BBBBBBB")
              changeWaiverSignedDate(data, playerHasSignedWaiver);
            }
            setPlayerModal(false);
            resetModal();
            console.log("Refreshing");
            refresh();
          });
      }
    }
  }
  function updatePlayer_post(api_fetch, data) {
    fetch(api_fetch, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((data) => {
      setPlayerModal(false);
      resetModal();
      refresh();
    });
  }
  
  function updatePlayer_top() {
    if (editMode) {
      if (baseEdit) {
        if (updateWaiverSignedDate) {
          changeWaiverSignedDate(playerId, playerHasSignedWaiver);
        }
        updatePlayer_post(devPort + "edit_player", {
          player_id: playerId,
          first_name: firstName,
          last_name: lastName,
          uspa_rating: playerUSPARating,
          club_rating: playerClubRating,
          club_id: clubId,
          is_club_pro: isPro,
        });
      } else {
        const edit_sginup_data = {
          'player_id': playerId,
          'club_id': clubId,
          'chukker_count': chukkerNumber,
          'game_id': gameId,
          'pro_id': idPro,
          'signup_notes': 'ancv',
          'division_chukkers': divisionChukkers
        }
        updatePlayer_post(
          devPort +
            "post_edit_signup",
            edit_sginup_data
        );
      }
    } else {
      if (baseEdit) {
        registerPlayer();
      }
    }
  }
  function changeWaiverSignedDate(playerId, playerHasSignedWaiver) {
    const fetch_player_waiver_signed_date =
      devPort + "change_player_signed_date";
    const change_waiver_siggned_date = {
      club_id: clubId,
      player_id: playerId,
      renewal_date: playerHasSignedWaiver
        ? moment().utc().format("YYYY-MM-DD")
        : "1970-01-01",
    };
    console.log(change_waiver_siggned_date);
    fetch(fetch_player_waiver_signed_date, {
      credentials: "include",
      mode: "cors",
      method: "POST",
      body: JSON.stringify(change_waiver_siggned_date),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Waiver Renewal");
        if (data && data["message"].match("Successful")) {
          console.log(data["message"]);
        }
      });
  }
  return (
    <Modal
      open={playerModal}
      onClose={() => {
        setPlayerModal(false);
      }}
      aria-labelledby="Player Edit"
      aria-describedby="Edit Player"
    >
      <Box sx={style}>
        <Stack spacing={2}>
          <TextField
            disabled={!baseEdit}
            id="player-first-name"
            data-testid="player-first-name"
            label="First Name"
            defaultValue={firstName}
            variant="filled"
            onChange={updateFirstName}
          />
          <TextField
            disabled={!baseEdit}
            id="player-last-name"
            label="Last Name"
            defaultValue={lastName}
            variant="filled"
            onChange={updateLastName}
          />
          {managerMode === -1 && baseEdit && (
            <div>
              <div>USPA Rating</div>
              <Box sx={{ width: 350 }}>
                <PoloRating
                  playerRating={playerUSPARating}
                  setPlayerRating={setPlayerUSPARating}
                  disabled={!baseEdit}
                />
              </Box>
              <div>Club Rating</div>
              <Box sx={{ width: 350 }}>
                <PoloRating
                  playerRating={playerClubRating}
                  setPlayerRating={setPlayerClubRating}
                  disabled={!baseEdit}
                />
              </Box>
            </div>
          )}
          <ChukkerDisplay />
          {baseEdit && managerMode === -1 && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="modal-is-pro"
                    checked={isPro}
                    onChange={() => setIsPro(!isPro)}
                  />
                }
                label="Is Pro Player"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="modal-has-signed-waiver"
                    checked={playerHasSignedWaiver}
                    onChange={() => {
                      setUpdateWaiverSignedDate(true);
                      setPlayerHasSignedWaiver(!playerHasSignedWaiver);
                    }}
                  />
                }
                label="Player Has Signed The Waiver"
              />
            </FormGroup>
          )}
          {!baseEdit && (
            <ProBox
              devPort={devPort}
              clubId={clubId}
              setIdPro={setIdPro}
              refresh={false}
              proRequest={proRequest}
            />
          )}
          {!baseEdit && (
            <GameDivisionRequest
              gameDivisionDetails={gameDivisions}
              totalDivisionChukkers={totalDivisionChukkers}
              chukkerRequested={chukkerNumber}
              setDivisionChukkers={setDivisionChukkers}
              divisionChukkers={divisionChukkers}
            />
          )}
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="success"
              onClick={updatePlayer_top}
            >
              Update
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                setPlayerModal(false);
                resetModal();
              }}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default RegistrationModal;
